import { render } from "./LeaderboardPage.vue?vue&type=template&id=4da3e0f0&scoped=true"
import script from "./LeaderboardPage.vue?vue&type=script&lang=js"
export * from "./LeaderboardPage.vue?vue&type=script&lang=js"

import "./LeaderboardPage.vue?vue&type=style&index=0&id=4da3e0f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da3e0f0"]])

export default __exports__